import EmailSignupForm from "@/components/wynn/EmailSignupForm";
import WaitlistCount from "@/components/wynn/WaitlistCount";

export default function Waitlist() {
  return (
    <section
      id="join"
      data-testid="wynn-waitlist"
      className="relative border-t border-[#F4F1EC]/10 scroll-mt-20 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(45% 50% at 80% 30%, rgba(255,170,210,0.16) 0%, rgba(7,6,8,0) 60%), radial-gradient(45% 50% at 15% 80%, rgba(168,230,255,0.14) 0%, rgba(7,6,8,0) 65%)",
        }}
      />
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body">
              Join the waitlist
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.05] text-[clamp(2rem,4.4vw,3.4rem)] font-medium text-[#F4F1EC]">
              Step inside the{" "}
              <span className="italic font-light text-aurora">first circle</span>.
            </h2>
            <p className="mt-6 font-body text-[#F4F1EC]/70 text-lg leading-[1.75] max-w-md">
              No launch noise. A simple letter when the doors quietly open. Beta
              testers keep founding-member pricing for life — and it&apos;s easy to
              leave any time.
            </p>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <div className="border border-[#F4F1EC]/15 bg-[#F4F1EC]/[0.035] backdrop-blur-sm p-8 md:p-10">
              <EmailSignupForm
                source="wynn_hero"
                testIdPrefix="wynn-hero"
                successDescription="You're on the WYNN waitlist. Beta invites go out first."
              />
              <div className="mt-6">
                <WaitlistCount
                  sourcePrefix="wynn"
                  threshold={50}
                  testId="wynn-hero-waitlist-count"
                  firstCircleCopy="Be among the first to step inside — the first quiet circle."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
